<template>
  <div class="stage-list">
    <div class="stage-block" v-for="(item, i) in stageViewList" :key="i">{{ item }}</div>
  </div>
</template>

<script>
const debounce = require('debounce')
export default {
  mixins: [],
  components: {},
  props: {
    stageList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      stageViewList: []
    };
  },
  computed: {},
  watch: {
    stageList(val){
      this.stageViewList=val;
    }
  },
  created() {
    this.stageViewList = this.stageList;
  },
  mounted() {
    this.resize()

    this.__resizeHandler = debounce(() => {
      this.resize()
    }, 100)

    window.addEventListener('resize', this.__resizeHandler)
  },
  beforeDestory() {
    window.removeEventListener('resize', this.__resizeHandler)
  },
  destroyed() {},
  methods: {
    resize() {
      let nums = (this.$el.parentElement.clientWidth - 40) / 64.0;

      if (nums < this.stageList.length) {
        this.stageViewList = this.stageList.slice(0, parseInt(nums) - 3);
        this.stageViewList.push("...");
        this.stageViewList.push(this.stageList[this.stageList.length - 1]);
      }else{
        this.stageViewList = this.stageList
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.stage-list {
  display: flex;
  justify-content: flex-start;

  .stage-block {
    min-width: 60px;
    width: 78px;
    height: 80px;
    display: flex;
    border-radius: 5px;
    border: 1px solid #b17f2d;
    color: #b17f2d;
    font-size: 13px;
    padding: 4px;
    align-items: center;
    box-sizing: border-box;

    margin-right: 6px;

    overflow: hidden;
    text-overflow: ellipsis;

    word-break: break-all;
    word-wrap: break-word;
    white-space: pre-wrap;

    background: url(../../assets/stage-process.png) no-repeat center;
  }

  .stage-block:last-child {
    background: url(../../assets/stage-end.png) no-repeat center;
  }
}
</style>
